import { render, staticRenderFns } from "./WishListing.vue?vue&type=template&id=6edb10b6&scoped=true&"
import script from "./WishListing.vue?vue&type=script&lang=ts&"
export * from "./WishListing.vue?vue&type=script&lang=ts&"
import style0 from "./WishListing.vue?vue&type=style&index=0&id=6edb10b6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edb10b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6edb10b6')) {
      api.createRecord('6edb10b6', component.options)
    } else {
      api.reload('6edb10b6', component.options)
    }
    module.hot.accept("./WishListing.vue?vue&type=template&id=6edb10b6&scoped=true&", function () {
      api.rerender('6edb10b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chat/WishListing.vue"
export default component.exports